import React from "react";
import Alert from "components/common/Alert";
import Avatar from "components/common/Avatar";
import CourseBadge from "components/common/CourseBadge";
import HtmlContent from "components/common/HtmlContent";
import CourseMaterialsForCoursePage from "components/courses/CourseMaterials";
import { COURSE_DISCLAIMER } from "constants/site";
import { getYear } from "helpers/dates";
import CourseTitle from "./CourseTitle";
import { CourseViewQueryAuthors, CourseViewQueryCourse } from "./__generated__/queries";
import styles from "./CourseHeader.module.css";

interface CourseHeaderProps {
  title: string;
  materials: CourseViewQueryCourse["materials"];
  authors: CourseViewQueryAuthors[];
  isNew: boolean | null;
  isRecentlyUpdated: boolean | null;
  date: string;
  updatedOn: string | null;
  showBadges: boolean;
  showContentDisclaimer?: boolean;
  courseMaterialsExtraText?: string | undefined;
}

const CourseHeader: React.FC<CourseHeaderProps> = ({
  title,
  authors,
  materials,
  isNew,
  isRecentlyUpdated,
  date,
  updatedOn,
  showBadges,
  showContentDisclaimer,
  courseMaterialsExtraText,
}) => {
  return (
    <div>
      {showBadges && !isRecentlyUpdated && isNew && (
        <CourseBadge type="new" label={`${getYear(date)}`} />
      )}{" "}
      {showBadges && isRecentlyUpdated && updatedOn && (
        <CourseBadge type="updated" label={`${getYear(updatedOn)}`} />
      )}
      <div className="my-2" />
      <CourseTitle>{title}</CourseTitle>
      {showContentDisclaimer ? (
        <Alert theme="info">
          <HtmlContent>{COURSE_DISCLAIMER}</HtmlContent>
        </Alert>
      ) : null}
      <div className={styles.courseMeta}>
        <div className="max-w-2xl">
          {!!authors && <Avatar textSize="lg" extended authors={authors} />}
          {!!materials && (
            <CourseMaterialsForCoursePage
              materials={materials}
              extraText={courseMaterialsExtraText}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CourseHeader;
